import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/RequestFollowUp"
    : "SLN/SolarentOperator/RequestFollowUp";

const RequestFollowUpApi = {
  create: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Create`, data),
  getByRequest: async (source, requestInfoId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetByRequest/${requestInfoId}`
    ),
};

export default RequestFollowUpApi;
